import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  COLLECTIONS_UPDATE_COLLECTION_META_DATA_TABLE_MAPPING_BEGIN,
  COLLECTIONS_UPDATE_COLLECTION_META_DATA_TABLE_MAPPING_SUCCESS,
  COLLECTIONS_UPDATE_COLLECTION_META_DATA_TABLE_MAPPING_FAILURE,
  COLLECTIONS_UPDATE_COLLECTION_META_DATA_TABLE_MAPPING_DISMISS_ERROR,
} from './constants';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function updateCollectionMetaDataTableMapping(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_UPDATE_COLLECTION_META_DATA_TABLE_MAPPING_BEGIN,
    });

    const { projectId, version, mappingId, selectedCollection, updatedValues } = args;
    const { uuid: collectionUuid } = selectedCollection;
    const header = builderSurfaceJsonContentHeader(projectId);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/meta-data-mapping/${collectionUuid}/collection/${mappingId}`,
        updatedValues,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_UPDATE_COLLECTION_META_DATA_TABLE_MAPPING_SUCCESS,
            data: res.data.metaDataTableMapping,
          });
          Mixpanel.track('Updated Meta Data Mapping in Collection');
          toast.success('Updated Successfully !');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_UPDATE_COLLECTION_META_DATA_TABLE_MAPPING_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to update meta data mapping in collection');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateCollectionMetaDataTableMappingError() {
  return {
    type: COLLECTIONS_UPDATE_COLLECTION_META_DATA_TABLE_MAPPING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_UPDATE_COLLECTION_META_DATA_TABLE_MAPPING_BEGIN:
      return {
        ...state,
        updateCollectionMetaDataTableMappingPending: true,
        updateCollectionMetaDataTableMappingError: null,
      };

    case COLLECTIONS_UPDATE_COLLECTION_META_DATA_TABLE_MAPPING_SUCCESS:
      return {
        ...state,
        updateCollectionMetaDataTableMappingPending: false,
        updateCollectionMetaDataTableMappingError: null,
        metaDataTableMappings: action.data,
      };

    case COLLECTIONS_UPDATE_COLLECTION_META_DATA_TABLE_MAPPING_FAILURE:
      return {
        ...state,
        updateCollectionMetaDataTableMappingPending: false,
        updateCollectionMetaDataTableMappingError: action.data.error,
      };

    case COLLECTIONS_UPDATE_COLLECTION_META_DATA_TABLE_MAPPING_DISMISS_ERROR:
      return {
        ...state,
        updateCollectionMetaDataTableMappingError: null,
      };

    default:
      return state;
  }
}
